export default "__VITE_ASSET__DVaxAFt2__"